// extracted by mini-css-extract-plugin
export var banner = "_ql-0";
export var settingRow = "_ql-2";
export var titleIcon = "_ql-1";